import axios from 'axios';
import {api} from '../utils/helper';

//****************** GET Org by Proj ******************//
export const getOrgByProj = async (a) => {
    try{
    const resrep = await axios.post(
      `${api}/getorgbyproj`, a,
      {
        headers: {
          authorization: sessionStorage.getItem('token'),
        },
      },
    );
//          console.log(`getOrgByProj controller res: `, resrep);
          return resrep;
    }catch (error) {
//        console.log(`getOrgByProj controller error: `, error?.response?.data);
        alert(error?.response?.data?.message);
    }

}